export const doctor = {
  Home: [
    {
      content: ["You have to select Doctors", "to load the appointments."],
      //   placement: "left",
      target: window.innerWidth < 768 ? ".doctorMobList" : ".doctorList",
      //   title: "Start Consultation",
      disableBeacon: true,
    },
  ],
};
